
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class ContactBlock extends Vue {
  @Prop(Object)
  block!: any;

  $helpers: any;

  getPhone(telephoneNumber: string): string {
    return 'tel:'.concat(telephoneNumber.split(' ').join(''));
  }

  getAvatarUrl(url: string): string {
    return this.$helpers.getFileUrl(url);
  }
}
